import React from 'react'

import { handleImageError } from '../../utils/helpers'

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string
    fallbackSrc?: string
}

const Image: React.FC<ImageProps> = ({ src, fallbackSrc, ...props }) => {
    return (
        <img
            {...props}
            src={src}
            onError={(e) => handleImageError(e, fallbackSrc)}
            alt={props.alt ?? 'not specified'}
        />
    )
}

export default Image
